import { splitAt } from 'ramda'
import React from 'react'

import { Label, SmallText } from '../../presentation/Text'
import { isFunction } from '../../../utils/helpers/types'
import { useFieldValue, useForm, useFormState } from './FormHandler'
import Input from '../Input'
import LoadingWrapper from '../../helpers/LoadingWrapper'
import { Col, Grid } from '../../structure/Grid'

const FormItem = ({
  form,
  field,
  path,
  label,
  logo,
  ignoreLabel,
  Input: CustomInput,
  children,
  afterChange,
  loading,
  index,
  disabled,
  value: propValue,
  ...props
}) => {
  const formFromContext = useForm()
  form = form || formFromContext || {}
  const { handleChangeIn } = useFormState()
  CustomInput = CustomInput || Input

  const [finalPath, [finalField]] = splitAt(-1, path || [field])
  const [value, error] = useFieldValue({ field, path })
  const color = error ? 'red' : undefined

  const isDisabled = typeof disabled === 'function' ? disabled(propValue || value, index) : disabled

  const handleChange = v => {
    handleChangeIn([...finalPath, finalField], v)
    isFunction(afterChange) && afterChange(v, { path: finalPath, field: finalField })
  }

  children = children || (
    <CustomInput
      value={value}
      onChange={handleChange}
      label={ignoreLabel && label}
      disabled={isDisabled}
      index={index}
      {...props}
    />
  )

  return (
    <LoadingWrapper loading={loading}>
      <Grid>
        <Col flex={1}>
          {!ignoreLabel && label && (
            <Label inline color={color}>
              {label}
            </Label>
          )}
        </Col>
        {logo && <Col>{logo}</Col>}
      </Grid>
      {children}
      <SmallText color={color}>{error}</SmallText>
    </LoadingWrapper>
  )
}

export default FormItem
